import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ViewIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='view-icon'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M14.5668 4.58212C14.5668 4.42773 14.6282 4.27967 14.7373 4.1705C14.8465 4.06133 14.9946 4 15.149 4H19.4179C19.5723 4 19.7203 4.06133 19.8295 4.1705C19.9387 4.27967 20 4.42773 20 4.58212V8.85103C20 9.00542 19.9387 9.15348 19.8295 9.26265C19.7203 9.37182 19.5723 9.43315 19.4179 9.43315C19.2635 9.43315 19.1154 9.37182 19.0063 9.26265C18.8971 9.15348 18.8358 9.00542 18.8358 8.85103V5.98698L14.008 10.8147C13.9547 10.8719 13.8905 10.9178 13.819 10.9496C13.7476 10.9814 13.6706 10.9985 13.5924 10.9999C13.5142 11.0013 13.4366 10.9869 13.3641 10.9576C13.2916 10.9284 13.2258 10.8848 13.1705 10.8295C13.1152 10.7742 13.0716 10.7084 13.0424 10.6359C13.0131 10.5634 12.9987 10.4858 13.0001 10.4076C13.0015 10.3294 13.0186 10.2524 13.0504 10.181C13.0822 10.1095 13.1281 10.0453 13.1853 9.99199L18.013 5.16425H15.149C14.9946 5.16425 14.8465 5.10292 14.7373 4.99375C14.6282 4.88458 14.5668 4.73651 14.5668 4.58212Z'
				fill='#2E2E6B'
			/>
			<path
				d='M4 6.38158C4 5.61895 4.61895 5 5.38158 5H12.0921C12.2491 5 12.3997 5.06238 12.5108 5.17342C12.6218 5.28446 12.6842 5.43507 12.6842 5.59211C12.6842 5.74914 12.6218 5.89975 12.5108 6.01079C12.3997 6.12183 12.2491 6.18421 12.0921 6.18421H5.38158C5.32923 6.18421 5.27903 6.205 5.24202 6.24202C5.205 6.27903 5.18421 6.32923 5.18421 6.38158V18.6184C5.18421 18.7274 5.27263 18.8158 5.38158 18.8158H17.6184C17.6708 18.8158 17.721 18.795 17.758 18.758C17.795 18.721 17.8158 18.6708 17.8158 18.6184V11.9079C17.8158 11.7509 17.8782 11.6003 17.9892 11.4892C18.1003 11.3782 18.2509 11.3158 18.4079 11.3158C18.5649 11.3158 18.7155 11.3782 18.8266 11.4892C18.9376 11.6003 19 11.7509 19 11.9079V18.6184C19 18.9848 18.8544 19.3362 18.5953 19.5953C18.3362 19.8544 17.9848 20 17.6184 20H5.38158C5.01516 20 4.66375 19.8544 4.40466 19.5953C4.14556 19.3362 4 18.9848 4 18.6184V6.38158Z'
				fill='#2E2E6B'
			/>
		</svg>
	);
};

export default ViewIcon;
